<script setup lang="ts">
const { params } = useShop();
const options = [
  { value: 9, text: "9" },
  { value: 12, text: "12" },
  { value: 24, text: "24" },
];
</script>

<template>
  <UiDropdown v-model="params.per_page" label="Par page:" :options="options" :default-value="12" />
</template>
